class ParagraphExpander {
	constructor() {
		this.documentSelector = '.search-results__header-content p';
		this.block = 'paragraph-expander';
		this.blockModifier = `${this.block}--expanded`;
		this.init();
		this.createEvents();
	}

	init() {
		Array.from(document.querySelectorAll(this.documentSelector)).forEach(
			(p, i) => {
				const paragraph = p.innerHTML;

				// looking for pattern: anchor tag with one space and data-link attribute
				// followed by any word and non word characters including spaces finished by
				// closing anchor tag
				const re = /<a\sdata-link[=""]*>[\w\W]+<\/a>/;

				if (re.test(paragraph)) {
					const boundary = paragraph.match(re);
					const paragraphParts = paragraph.split(boundary);

					const linkText = `<a id="paragraph-expander-link-${i}" href="#" data-${
						this.block
					} data-cm="${this.getCategoryID()}"><span>&hellip;</span> ${boundary[0].slice(
						16,
						-4,
					)}</a>`;

					p.innerHTML = `${paragraphParts[0]} ${linkText} <span id="paragraph-expander-content-${i}" data-paragraph-expander>${paragraphParts[1]}</span>`;
					p.classList.add(this.block);
					this.createStyle();
				}
			},
		);
	}

	getCategoryID() {
		return window.od &&
			window.od.journeyData &&
			window.od.journeyData.navigation &&
			(typeof window.od.journeyData.navigation.categoryID === 'string' ||
				typeof window.od.journeyData.navigation.categoryID === 'number')
			? window.od.journeyData.navigation.categoryID
			: '';
	}

	replaceLink(evt) {
		evt.preventDefault();
		evt.stopPropagation();
		evt.target.parentElement.classList.add(this.blockModifier);
		window.od.events.publish(
			'seoText_read_more_Click',
			evt.target.getAttribute('data-cm'),
		);
	}

	// as this is a test for the BA the following code in createStyles will be moved to .scss if
	// the business wants to have this as a permanent solution.
	createStyle() {
		const style = document.createElement('style');
		style.setAttribute('type', 'text/css');

		style.innerHTML = `
			@media (max-width: 480px) {
				.${this.block} span[data-${this.block}] {
					display: none;
				}
		
				.${this.blockModifier} span[data-${this.block}] {
					display: inline;
				}
				
				.${this.block} a[data-${this.block}] {
					text-decoration: none;
				}
		
				.${this.blockModifier} a[data-${this.block}] {
					display: none;
				}
				
				.${this.block} a[data-${this.block}]:link span,
				.${this.block} a[data-${this.block}]:hover span,
				.${this.block} a[data-${this.block}]:visited span {
					color: #30302E;
				}
			}
			@media (min-width: 481px) {
				.${this.block} span[data-${this.block}] {
					display: inline;
				}
				
				.${this.block} a[data-${this.block}] {
					display: none;
				}
			}	
		`;

		document.getElementsByTagName('head')[0].appendChild(style);
	}

	createEvents() {
		Array.from(document.querySelectorAll(`a[data-${this.block}]`)).map(el =>
			el.addEventListener('click', this.replaceLink.bind(this)),
		);
	}
}

export default ParagraphExpander;
